import React from 'react'

import styles from './FormShadow.module.scss'

export default () => <div className={styles['shadow']}></div>
